import SetupStepsList from "./SetupStepsList";
import TokenPermissionsPanel from "./TokenPermissionsPanel";

/** Page-level banner for connect / update outcomes with optional setup steps. */
const ConnectResultBanner = ({ result, onDismiss }) => {
  if (!result) return null;

  const { type, title, message, setupSteps, webhookNote, tokenDebug } = result;

  const styles = {
    success: {
      wrap: "bg-emerald-50 border-emerald-200",
      icon: "text-emerald-600",
      title: "text-emerald-900",
      body: "text-emerald-800",
    },
    partial: {
      wrap: "bg-amber-50 border-amber-200",
      icon: "text-amber-600",
      title: "text-amber-900",
      body: "text-amber-800",
    },
    error: {
      wrap: "bg-red-50 border-red-200",
      icon: "text-red-600",
      title: "text-red-900",
      body: "text-red-800",
    },
  };

  const s = styles[type] || styles.error;

  return (
    <div className={`mb-6 border rounded-2xl p-4 ${s.wrap}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          {title && <p className={`text-sm font-bold mb-1 ${s.title}`}>{title}</p>}
          {message && <p className={`text-sm ${s.body}`}>{message}</p>}
          {webhookNote && (
            <p className={`text-xs mt-2 ${type === "success" ? "text-emerald-700" : "text-amber-700"}`}>
              {webhookNote}
            </p>
          )}
          {setupSteps?.length > 0 && (
            <div className="mt-3">
              <SetupStepsList steps={setupSteps} compact />
            </div>
          )}
          {tokenDebug && (
            <div className="mt-3">
              <TokenPermissionsPanel tokenDebug={tokenDebug} compact />
            </div>
          )}
        </div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="text-gray-500 hover:text-gray-700 text-sm font-medium flex-shrink-0"
          >
            Dismiss
          </button>
        )}
      </div>
    </div>
  );
};

export default ConnectResultBanner;
